import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companies } from '../data/mockData';

const Footer = () => {
  const { holding } = companies;

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/bjvkd39u_69a21436-daff-4718-9fb3-cf55e72e960d.jpeg" 
              alt="immoriya" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed">
              Immobilienwerte entwickeln, sanieren und verwalten – mit unternehmerischem Weitblick und lokaler Verwurzelung in Osnabrück.
            </p>
          </div>

          {/* Unternehmensgruppe */}
          <div>
            <h3 className="text-white font-semibold mb-4">Unternehmensgruppe</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/energiya" className="text-sm hover:text-blue-400 transition-colors">
                  Energiya GmbH
                </Link>
              </li>
              <li>
                <Link to="/mynah" className="text-sm hover:text-blue-400 transition-colors">
                  MYNAH GmbH
                </Link>
              </li>
              <li>
                <Link to="/mk" className="text-sm hover:text-blue-400 transition-colors">
                  MK Immobilienverwaltung GmbH
                </Link>
              </li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h3 className="text-white font-semibold mb-4">Rechtliches</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/impressum/holding" className="text-sm hover:text-blue-400 transition-colors">
                  Impressum immoriya
                </Link>
              </li>
              <li>
                <Link to="/impressum/energiya" className="text-sm hover:text-blue-400 transition-colors">
                  Impressum Energiya
                </Link>
              </li>
              <li>
                <Link to="/impressum/mynah" className="text-sm hover:text-blue-400 transition-colors">
                  Impressum MYNAH
                </Link>
              </li>
              <li>
                <Link to="/impressum/mk" className="text-sm hover:text-blue-400 transition-colors">
                  Impressum MK
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm hover:text-blue-400 transition-colors">
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  {holding.address.street}<br />
                  {holding.address.zip} {holding.address.city}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href={`tel:${holding.contact.phone}`} className="text-sm hover:text-blue-400 transition-colors">
                  {holding.contact.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href={`mailto:${holding.contact.email}`} className="text-sm hover:text-blue-400 transition-colors">
                  {holding.contact.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="text-center">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} {holding.name}. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
